import { Routes, Route, Navigate, RouteProps, RoutesProps } from "react-router-dom";

import React, { Suspense, useEffect } from "react";
import { useState } from "react";
import ProtectedRoute from "./ProtectedRoute";
import Main from "../components/Main";
import Parkdetails from "../pages/Parkdetails/Parkdetails";
import Pastpark from "../pages/Pastpark/Pastpark";
import Account from "../pages/Account/Account";
import { RequestPage, Support } from "@mui/icons-material";
import Supportpage from "../pages/Supportpage/Supportpage";
import Requestcall from "../pages/Requestcall/Requestcall";
import { Chat, Stripe } from "react-bootstrap-icons";
import Chatsupport from "../pages/Chatsupport/Chatsupport";
import Profile from "../pages/Profile/Profile";
import Editprofile from "../pages/Editprofile/Editprofile";
import Myvehicles from "../pages/Myvehicles/Myvehicles";
import Addvehicles from "../pages/Addvehicles/Addvehicles";
import Stripepage from "../pages/Stripepage/Stripepage";
import Mappage from "../pages/Mappage/Mappage";
import Addmoney from "../pages/Addmoney/Addmoney";
import ParkingSessionDetail from "../pages/Pastpark/ParkingSessionDetail";

const Navigation = () => {
  interface ProtectedRouteProps extends RoutesProps {
    authenticationPath: string;
  }
  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    authenticationPath: "/login",
  };

  const Dashboard = React.lazy(() => import("../pages/Dashboard/Dashboard"));
  const Register = React.lazy(() => import("../pages/Register/Register"));
  const Login = React.lazy(() => import("../pages/Login/Login"));
  const Otp = React.lazy(() => import("../pages/Otp/Otp"));
  const Homepage = React.lazy(() => import("../pages/Homepage/Homepage"));
  const ClosingReceipt = React.lazy(() => import("../pages/Homepage/ClosingReceipt"));
  const Subscription = React.lazy(() => import("../pages/Subscription/Subscription"));
  const Forgot = React.lazy(() => import("../pages/Forgot/Forgot"));
  const Resetpassword = React.lazy(() => import("../pages/Resetpassword/Resetpassword"));
  const Confirmlocation = React.lazy(() => import("../pages/Confirmlocation/Confirmlocation"));
  const parkdetails = React.lazy(() => import("../pages/Parkdetails/Parkdetails"));
  const Pastpark = React.lazy(() => import("../pages/Pastpark/Pastpark"));
  const ParkingSessionDetail = React.lazy(() => import("../pages/Pastpark/ParkingSessionDetail"));
  const supportpage = React.lazy(() => import("../pages/Supportpage/Supportpage"));
  const SelectVehicle = React.lazy(() => import("../pages/SelectVehicle/SelectVehicle"));

  const account = React.lazy(() => import("../pages/Account/Account"));
  const requestcall = React.lazy(() => import("../pages/Requestcall/Requestcall"));
  const chatsupport = React.lazy(() => import("../pages/Chatsupport/Chatsupport"));
  const profile = React.lazy(() => import("../pages/Profile/Profile"));
  const editprofile = React.lazy(() => import("../pages/Editprofile/Editprofile"));
  const myvehicles = React.lazy(() => import("../pages/Myvehicles/Myvehicles"));
  const addvehicles = React.lazy(() => import("../pages/Addvehicles/Addvehicles"));
  const stripepage = React.lazy(() => import("../pages/Stripepage/Stripepage"));
  const mappage = React.lazy(() => import("../pages/Mappage/Mappage"));
  const addmoney = React.lazy(() => import("../pages/Addmoney/Addmoney"));

  

  return (
    <>
      <div id="main-wraper">
        <Routes>
        <Route path="/" element={<Navigate replace to="/login" />} />

        <Route
              path="/login"
              element={
                <Suspense fallback={<></>}>
                  <Login />
                </Suspense>
              }
            />
               <Route
              path="/otp"
              element={
                <Suspense fallback={<></>}>
                  <Otp />
                </Suspense>
              }
            /> 

            <Route
              path="/register"
              element={
                <Suspense fallback={<></>}>
                  <Register />
                </Suspense>
              }
            />
          <Route path="/" element={<ProtectedRoute {...defaultProtectedRouteProps} outlet={<Main />} />}>
            <Route
              path="/dashboard"
              element={
                <Suspense fallback={<></>}>
                  <Dashboard />
                </Suspense>
              }
            />
            <Route
              path="/SelectVehicle"
              element={
                <Suspense fallback={<></>}>
                  <SelectVehicle />
                </Suspense>
              }
            />
            {/* <Route
              path="/login"
              element={
                <Suspense fallback={<></>}>
                  <Login />
                </Suspense>
              }
            />
            <Route
              path="/otp"
              element={
                <Suspense fallback={<></>}>
                  <Otp />
                </Suspense>
              }
            /> */}
            
            <Route
              path="/homepage"
              element={
                <Suspense fallback={<></>}>
                  <Homepage />
                </Suspense>
              }
            />
            <Route
              path="/subscription"
              element={
                <Suspense fallback={<></>}>
                  <Subscription />
                </Suspense>
              }
            />
            <Route
              path="/forgot"
              element={
                <Suspense fallback={<></>}>
                  <Forgot />
                </Suspense>
              }
            />
            <Route
              path="/confirmlocation"
              element={
                <Suspense fallback={<></>}>
                  <Confirmlocation />
                </Suspense>
              }
            />
            <Route
              path="/ClosingReceipt"
              element={
                <Suspense fallback={<></>}>
                  <ClosingReceipt />
                </Suspense>
              }
            />

            <Route
              path="/resetpassword"
              element={
                <Suspense fallback={<></>}>
                  <Resetpassword />
                </Suspense>
              }
            />

            <Route
              path="/parkdetails"
              element={
                <Suspense fallback={<></>}>
                  <Parkdetails />
                </Suspense>
              }
            />
            <Route
              path="/ParkingSessionDetail"
              element={
                <Suspense fallback={<></>}>
                  <ParkingSessionDetail />
                </Suspense>
              }
            />
            <Route
              path="/supportpage"
              element={
                <Suspense fallback={<></>}>
                  <Supportpage />
                </Suspense>
              }
            />
            <Route
              path="/account"
              element={
                <Suspense fallback={<></>}>
                  <Account />
                </Suspense>
              }
            />
            <Route
              path="/profile"
              element={
                <Suspense fallback={<></>}>
                  <Profile />
                </Suspense>
              }
            />

            <Route
              path="/requestcall"
              element={
                <Suspense fallback={<></>}>
                  <Requestcall />
                </Suspense>
              }
            />

            <Route
              path="/pastpark"
              element={
                <Suspense fallback={<></>}>
                  <Pastpark />
                </Suspense>
              }
            />
            <Route
              path="/editprofile"
              element={
                <Suspense fallback={<></>}>
                  <Editprofile />
                </Suspense>
              }
            />
            <Route
              path="/myvehicles"
              element={
                <Suspense fallback={<></>}>
                  <Myvehicles />
                </Suspense>
              }
            />
            <Route
              path="/addvehicles"
              element={
                <Suspense fallback={<></>}>
                  <Addvehicles />
                </Suspense>
              }
            />
            <Route
              path="/stripepage"
              element={
                <Suspense fallback={<></>}>
                  <Stripepage />
                </Suspense>
              }
            />

            <Route
              path="/chatsupport"
              element={
                <Suspense fallback={<></>}>
                  <Chatsupport />
                </Suspense>
              }
            />
            <Route
              path="/addmoney"
              element={
                <Suspense fallback={<></>}>
                  <Addmoney />
                </Suspense>
              }
            />
            <Route
              path="/mappage"
              element={
                <Suspense fallback={<></>}>
                  <Mappage />
                </Suspense>
              }
            />
          </Route>
        </Routes>
      </div>
    </>
  );
};

export default Navigation;
